import { render, staticRenderFns } from "./ResumenPayment.vue?vue&type=template&id=15242b9a"
import script from "./ResumenPayment.vue?vue&type=script&lang=js"
export * from "./ResumenPayment.vue?vue&type=script&lang=js"
import style0 from "./ResumenPayment.vue?vue&type=style&index=0&id=15242b9a&prod&lang=css"
import style1 from "./ResumenPayment.vue?vue&type=style&index=1&id=15242b9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports